<template>
  <el-dialog
    title="协议确认"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="protocol-content">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="隐私政策" name="privacy">
          <div class="protocol-text">
            <h3>隐私政策</h3>
            <p><strong>概要</strong></p>
            <p>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
            <p>电子邮件：********</p>
            <p><strong>本政策将帮助您了解以下内容：</strong></p>
            <ol>
              <!-- <li>我们如何收集和使用您的个人信息</li>
              <li>我们如何使用 Cookie 和同类技术</li>
              <li>我们如何共享、转让和披露您的个人信息</li>
              <li>我们如何保护您的个人信息</li>
              <li>您的权利</li>
              <li>您的个人信息如何在全球范围转移</li>
              <li>本政策如何更新</li> -->
              <li>如何联系我们</li>
            </ol>
          </div>
        </el-tab-pane>
        <el-tab-pane label="使用条款" name="terms">
          <div class="protocol-text">
            <h3>使用条款</h3>
            <!-- <p>欢迎使用大智的产品和服务。本使用条款（以下简称 "本条款"）是您与大智之间关于使用大智产品和服务的法律协议。</p> -->
            <p>请您务必审慎阅读、充分理解本条款各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。</p>
            <p>如您对本条款有任何疑问，可通过客服渠道联系我们。</p>
            <p>您点击 "同意" 或 "下一步" 按钮，或使用产品和服务，即表示您已充分理解并同意本条款的全部内容。</p>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-checkbox v-model="agreed">我已查看并同意隐私政策及使用条款</el-checkbox>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">退出登录</el-button>
      <el-button type="primary" @click="handleAgree" :disabled="!agreed">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 'privacy',
      agreed: false
    }
  },
  methods: {
    handleCancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    },
    handleAgree() {
      if (this.agreed) {
        this.$emit('update:visible', false);
        this.$emit('agree');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.protocol-content {
  .protocol-text {
    max-height: 400px;
    overflow-y: auto;
    margin-bottom: 20px;
    padding-right: 10px;
    
    h3 {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 15px;
      color: #303133;
    }
    
    p {
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 10px;
      color: #606266;
    }
    
    ol {
      margin-left: 20px;
      margin-bottom: 10px;
      
      li {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 5px;
        color: #606266;
      }
    }
  }
  
  .el-checkbox {
    margin-top: 15px;
  }
}

.dialog-footer {
  text-align: right;
}
</style>